$(document).ready(function(){
  $(".faq-question").click(function(){
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });

  $(".link-close-icon").click(function(){
    $(".popup-close-icon").click();
  });

  if ( $(window).width() < 799){
  $('.footer-icon-section .container').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false
  });
  
  $(window).on('resize', function() {
      $('.footer-icon-section .container').slick('resize');
  });
  }

if ( $(window).width() < 799){
$('a[href^="#"]').on('click',function (e) {
  var target = this.hash,
      $target = $(target);
 
  $('html, body').stop().animate({
    'scrollTop': $target.offset().top-85
  }, 900, 'swing', function () {
    window.location.hash = target;
  });
});
}else{
  $('a[href^="#"]').on('click',function (e) {
  var target1 = this.hash,
      $target1 = $(target1);

  $('html, body').stop().animate({
    'scrollTop': $target1.offset().top-70
  }, 900, 'swing', function () {
    window.location.hash = target;
  });
});
}

   $(".cart_btn_active, #custom-by-btn").click(function(){
     event.preventDefault();
     $('button.shopify-payment-button__button.shopify-payment-button__button--unbranded').trigger('click'); 
  });

   $(".mobile-menu__item").click(function(){
     $('.mobile-menu__toggle-button').trigger('click'); 
  });



  
  function matchAndAddActiveClass(){ 
    var variantValue = $('.variant-option-option').find('option:selected').val();
    $('.variant_price_wrap').removeClass('active');
    $('.variant_price_wrap').each(function() {
      if ($(this).attr('variant-data-index') === variantValue) {
        $(this).addClass('active');
      }
    });
  }
  matchAndAddActiveClass();
  $('.variant-option-option').change(function() {
    matchAndAddActiveClass();
  });

   function handlePopState(event) {
      location.reload();
    }



    // function updateInputValue() {
    //   var selectedValue = document.querySelector(".variant-option-option").value;
    //   var inputElement = document.querySelector("#custom_qty_input");
    //   var numericValue = selectedValue.includes(' Stuks') ? selectedValue.split(' ')[0] : selectedValue;
    //   inputElement.value = numericValue;
    // }
    // document.querySelector(".variant-option-option").addEventListener("change", updateInputValue);
   
  
});